import { render, staticRenderFns } from "./EmpresasLista.vue?vue&type=template&id=4c9eba18&scoped=true"
import script from "./EmpresasLista.vue?vue&type=script&lang=js"
export * from "./EmpresasLista.vue?vue&type=script&lang=js"
import style0 from "./EmpresasLista.vue?vue&type=style&index=0&id=4c9eba18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9eba18",
  null
  
)

export default component.exports